import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
/* Components */
import ETokenDetail from "../../components/EToken/ETokenDetail";
import NotFound from "../NotFound/notFound";
import Loader from "react-js-loader";
/* Selectors */
import * as actionTypes from "@store/eTokens/actionTypes";
import * as selectors from "@store/eTokens/selectors";
/* i18n */
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { images } from "@/config";

const EToken = ({ state }) => {
  let dispatch = useDispatch();
  let current = selectors.selectCurrent(state);
  let currentAddress = selectors.selectCurrentAddr(state);
  const params = useParams();

  // Dispatch SET_SELECTED_ETOKEN if address in URL changed
  useEffect(() => {
    if (currentAddress !== params.name) {
      dispatch({ type: actionTypes.SET_SELECTED_ETOKEN, address: params.name });
    }
  }, [currentAddress, params.name, dispatch]);

  return (
    <>
      {selectors.selectCurrentExists(state) === undefined && !selectors.selectCurrentIsReady(state) ? (
        <div className="page-content loader">
          <Loader type="spinner-default" height={50} width={100} timeout={1000} />
        </div>
      ) : selectors.selectCurrentExists(state) === -1 ? (
        <NotFound />
      ) : (
        current && (
          <React.Fragment>
            <div className="page-content">
              <Container fluid>
                <Row>
                  <Col className="col-12">
                    <br />
                    <div style={{ fontSize: "28px" }}>
                      <span className="logo-sm">
                        <img src={current.logo || images.defaultEtkLogo} alt="" height="35" />
                      </span>{" "}
                      {current.name}
                    </div>
                  </Col>
                  <Col className="col-12">
                    <ETokenDetail eToken={current} />
                  </Col>
                </Row>
              </Container>
              <br />
              <br />
            </div>
          </React.Fragment>
        )
      )}
    </>
  );
};

EToken.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = (state) => {
  return { state: state.ETokensReducer };
};

export default connect(mapStateToProps)(withTranslation()(EToken));
